module.exports = __webpack_public_path__ + "img/step24_a_install supports.3d88c9e5.png";